// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var StorageURI = function (x) {
    return x;
};
var tsBridgeStorageURI = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("StorageURI")("__brandStorageURI"));
    }
};
var writeStorageURI = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showStorageURI = Data_Show.showString;
var readStorageURI = Simple_JSON.readString;
var ordStorageURI = Data_Ord.ordString;
var newtypeStorageURI = {
    Coercible0: function () {
        return undefined;
    }
};
var makeStorageURI = StorageURI;
var eqStorageURI = Data_Eq.eqString;
export {
    StorageURI,
    makeStorageURI,
    unwrap,
    newtypeStorageURI,
    eqStorageURI,
    ordStorageURI,
    showStorageURI,
    readStorageURI,
    writeStorageURI,
    tsBridgeStorageURI
};
//# sourceMappingURL=index.js.map
